import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import { ForeignBusinessVotingItemModel } from '../types';

const foreignBusinessVotingItemValidator: ValidateJSModel<ForeignBusinessVotingItemModel> = {
  Date: (value, attributes, attributeName, options) => ({
    presence: true,
    date: { earliest: options?.applicantBirthdate, latest: DEFAULT_LATEST },
  }),

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Reason: { hasValue: true },

  Eligibility: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },

  CurrentlyEligible: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: { validator: hasYesOrNo } };
    }

    return {};
  },

  CurrentlyEligibleExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.CurrentlyEligible?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },
};

export default foreignBusinessVotingItemValidator;
